export const wrapBgImage = (path) => `url(${path})`;
